import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  TextField,
  Typography,
} from '@mui/material';
import axios from 'axios';


const SUBSCRIBER_LOGIN_SUBMIT_URL = '/subscriber/login/submit';
const STATUS_SUCCESS = 'SUCCESS';
const STATUS_EMAIL_ERROR = 'EMAIL_ERROR';
const STATUS_ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND';

export const SubscriberLoginForm = () => {
  const [status, setStatus] = useState({});
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {

  }, [status]);

  const handleEmailChange = event => {
    setEmail(event.target.value);
  };

  const handleEnterPress = event => {
    if(event.keyCode === 13) {
      setEmail(event.target.value);
    }
  };

  const getFormObject = () => {
    return {
      email: email
    };
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!email) {
      setErrorMessage("Email address is a required field.");
      return;
    }
    setSubmitLoading(true);
    setErrorMessage('');
    setIsSuccess(false);
    try {
      // await new Promise((resolve) => setTimeout(resolve, 2500));
      const response = await axios.post(SUBSCRIBER_LOGIN_SUBMIT_URL, getFormObject());
      const submitResponseData = response.data;
      const responseStatus = submitResponseData.status;
      switch (responseStatus) {
        case STATUS_EMAIL_ERROR:
        case STATUS_ACCOUNT_NOT_FOUND:
          setErrorMessage(submitResponseData.message);
          break;
        case STATUS_SUCCESS:
          setIsSuccess(true);
          break;
        default:
          setErrorMessage('An error occurred saving your email address. Please try again.')
          break;
      }
    } catch (error) {
      console.error("Submit failed - an error occurred:", error);
      setErrorMessage('A server error has occurred.  Please try again.')
    } finally {
      setSubmitLoading(false);
    }
  };
  return (
    <>
      <Container maxWidth="sm">
        <Box component="form" onSubmit={handleSubmit} noValidate autoComplete="off" sx={{padding:'65px 0'}}>
          <Typography
            variant="h2"
            component="h1"
          >
            Subscriber Login
          </Typography>
          <Typography>
            Log in to update your AFCS job opportunity subscription preferences.
          </Typography>
          <TextField
            sx={{marginTop: '10px'}}
            variant="outlined"
            label="Your email"
            type="email"
            onBlur={handleEmailChange}
            onKeyDown={handleEnterPress}
            required={true}
            error={!!errorMessage}
            InputProps={{
              'aria-describedby': errorMessage ? 'email-message' : undefined
            }}
            fullWidth
            helperText="Please enter your email address to receive a one-time login link. Click this link in the email to complete your login."
          />
          {errorMessage &&
            <Alert sx={{marginY: '4px'}} id="email-message" severity="error">
              {errorMessage}
            </Alert>
          }
          {isSuccess &&
            <Alert sx={{marginY: '4px'}} id="email-success" severity="success">
              An email containing a login link has been sent to your address.  Please click the link to complete your login.
            </Alert>
          }
          <Box align="center" sx={{marginTop: '8px'}}>
            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{padding: '12px 50px'}}
              disabled={submitLoading}
              startIcon={submitLoading ? <CircularProgress size={24} color="inherit" /> : null}
            >
              {submitLoading ? 'Sending login link...' : 'Send login link'}
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
};